import { cn } from '@/lib/utils';
import { Product } from '@/services/api/contracts/catalog/types';
import { FC } from 'react';
import CatalogueExplorerProductCard from '../explorer/CatalogueExplorerProductCard';
import ProductCarousel from './ProductCarousel';

interface Props {
  products: Product[];
  carouselMode?: boolean;
}

export const ProductsList: FC<Props> = ({ products, carouselMode }) => {
  return (
    <>
      {!carouselMode || products.length < 4 ? (
        <div
          className={cn('grid h-fit grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4', carouselMode && 'mx-16')}
        >
          {products.map(product => (
            <CatalogueExplorerProductCard product={product} key={product.id} />
          ))}
        </div>
      ) : (
        <ProductCarousel products={products} />
      )}
    </>
  );
};
